import { type ReactNode } from 'react';
import Grid2 from '@mui/material/Unstable_Grid2';
import { InfoBannerWithLink } from '../InfoBannerWithLink';
import { SelectCompany } from '../SelectCompany';

type IntegrationContainerProps = {
  setSelectedCompany: (value: string) => void;
  guideUrl?: string;
  children: ReactNode;
};

export const IntegrationContainer = ({ children, setSelectedCompany, guideUrl }: IntegrationContainerProps) => {
  return (
    <Grid2>
      {guideUrl && (
        <Grid2 mb={2}>
          <InfoBannerWithLink guideUrl={guideUrl} />
        </Grid2>
      )}
      <Grid2 mb={4}>
        <SelectCompany setSelectedCompany={setSelectedCompany} />
      </Grid2>
      {children}
    </Grid2>
  );
};
